<pgh-modal-window size="sm">
  <div modal-close class="coverage-ended-modal__close">
    <span class="coverage-ended-modal__icon" aria-hidden="true">
      <mat-icon svgIcon="information-circle"></mat-icon>
    </span>
    <button type="button" mat-icon-button sf-aria-label="Global_Close_Window" matDialogClose class="coverage-ended-modal__close-btn">
      <mat-icon class="close-icon-gray">close</mat-icon>
    </button>
  </div>

  <h2 modal-title id="coverageEndedServiceModalTitle" class="coverage-ended-modal__title header-bold-l">
    <adp-label labelKey="Global_Coverage_Ended_ServiceRequest_Modal_Title"></adp-label>
  </h2>

  <div modal-body class="coverage-ended-modal">
    <p class="coverage-ended-modal__description paragraph-body-l-reg">
      <adp-label [context]="descriptionContext" labelKey="Global_Coverage_Ended_ServiceRequest_Modal_Description"></adp-label>
    </p>
  </div>

  <div modal-footer class="coverage-ended-modal__footer">
    <button type="button" mat-flat-button color="accent" (click)="onContinue()">
      <adp-label labelKey="Global_Button_Continue"></adp-label>
    </button>
  </div>
</pgh-modal-window>
